import * as React from 'react';
import '../hmilib/hmiglobal';

import { Header, IconButton, IToastData, ToastList } from '@ixyberfree/ixybercomponents';

import { GetGuid } from 'components/common/lib';
import LoadPage from 'components/MainPage/LoadPage';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStores } from 'store';
import PopupMessage from './PopupMessage/popupMessage';
import TreeAPC, { ITreeAPC_branch } from './TreeAPC/TreeAPC';

interface IProps {
    auth: {
        visibleAuth: boolean;
        authenticated: boolean;
        settingTrue: boolean;
        nameUser: string;
        callbackLogin: Function;
        callbackLogout: Function;
    };
}

const MainControl: React.FC<IProps> = ({ auth }) => {
    const { SystemStore } = useStores();
    const [loadState, setLoadState] = useState(false);
    const [openWindowTree, setOpenWindowTree] = useState(false);
    const [pinWindowTree, setPinWindowTree] = useState(false);
    const [tree, setTree] = useState<ITreeAPC_branch[]>([]);
    const [visibleTree, setVisibleTree] = useState<boolean>(true);
    const [selectedElement, setSelectedElement] = useState<string>('');
    const [selectedElementPath, setSelectedElementPath] = useState<string>('');
    const [selectedBranch, setSelectedBranch] = useState<ITreeAPC_branch | undefined>(undefined);
    const [toastMessage, setToastMessage] = useState<string>('');
    const [toasts, setToasts] = React.useState<IToastData[]>([]);
    const [baseData, setBaseData] = useState<any>();

    useEffect(() => {
        if (SystemStore.loadState) {
            // console.log(baseView);
            const url = '/ixyber/vision/pages/baseView.json';
            fetch(url)
                .then((res) => res.json())
                .then((res) => {
                    if (res.view == 'single') {
                        setVisibleTree(false);
                        if (res.pathMnemo) {
                            window.OpenMnemo(res.pathMnemo);
                        }
                        setLoadState(true);
                    } else {
                        getConf();
                    }
                })
                .catch((data) => {
                    getConf();
                });
            // getConf();
        }
    }, [SystemStore.loadState]);

    function selectClick(name: string) {
        setSelectedElement(name);
        getConf(name);
    }

    useEffect(() => {
        if (SystemStore.message) showToast(SystemStore.message);
    }, [SystemStore.message]);

    function showToast(message: string) {
        SystemStore.message = '';
        const toast: IToastData = {
            id: GetGuid(),
            message,
            isError: true,
            exit: true
        };

        setToasts((prevToasts) => [...prevToasts, toast]);

        setTimeout(() => {
            removeToast(toast.id!);
        }, 5 * 1000);
    }

    function removeToast(id: string) {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }

    useEffect(() => {
        if (SystemStore.mnemoPath.path && SystemStore.mnemoPath.bindings) {
            const parentPath = getParentPath(SystemStore.mnemoPath.bindings);
            const file = SystemStore.mnemoPath.path;
            if (parentPath && tree[0]) {
                const obj = findObjectByPath(tree[0], file, parentPath);
                setSelectedBranch(obj || undefined);
                if (obj?.path) {
                    setSelectedElementPath(obj.path.replace(/\//g, ' >> '));
                }
            }
        }
    }, [SystemStore.mnemoPath]);

    const getChildWithFile = (children: any[], file: string): ITreeAPC_branch | undefined =>
        children.find((child) => child.file && child.file.includes(file));

    const findObjectByPath = (obj: any, file: string, parentPath: string): ITreeAPC_branch | undefined => {
        if (obj.path === parentPath && Array.isArray(obj.children)) {
            return getChildWithFile(obj.children, file);
        }

        for (const child of obj.children ?? []) {
            const result = findObjectByPath(child, file, parentPath);
            if (result) return result;
        }

        return undefined;
    };

    function getParentPath(binding: string) {
        const match = binding.match(/parentpath=([^"]+)/i);
        return match ? match[1] : null;
    }

    function extractFileName(file: string): string {
        return (
            file
                .split(/[/\\]/)
                .pop()
                ?.replace(/\.\w+$/, '') || ''
        );
    }

    function updateConf(obj: any, selectedElem?: string): any | null {
        const branch: ITreeAPC_branch = {
            name: obj.subname === null || obj.subname === '' ? obj.name : obj.subname,
            type: 'folder',
            children: [],
            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj.icon,
            file: obj.file || null,
            path: obj.path,
            clickCallBack: () => {
                setSelectedBranch(obj);
            }
        };

        let hasMnemosInBranch = false;

        if (obj.mnemos && Object.keys(obj.mnemos).length > 0) {
            hasMnemosInBranch = true;
            for (let mKey in obj.mnemos) {
                const mBranch: ITreeAPC_branch = {
                    name: obj.mnemos[mKey].subname === null ? obj.mnemos[mKey].name : obj.mnemos[mKey].subname,
                    type: 'file',
                    iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj.mnemos[mKey].icon,
                    children: [],
                    file: obj.mnemos[mKey].file,
                    path: obj.mnemos[mKey].path,
                    clickCallBack: async () => {
                        await window.OpenMnemo(`${obj.mnemos[mKey].file}?parentpath=${obj.path}`);
                        selectClick(`${obj.mnemos[mKey].file}?parentpath=${obj.path}`);
                        setSelectedElementPath(obj.path.replace(/\//g, ' >> '));
                    }
                };
                if (branch.children !== undefined) {
                    branch.children.push(mBranch);
                }
            }
        }

        if (obj.blocks) {
            branch.type = 'folder';
            switch (obj.type) {
                case 'ProfitController': {
                    branch.iconUrl = '/ixyber/vision/static/images/tree_icon/gears.svg';
                    break;
                }
            }
            for (let key in obj.blocks) {
                let temp = updateConf(obj.blocks[key], selectedElem);
                if (temp !== null && branch.children !== undefined) {
                    branch.children.push(temp);
                    hasMnemosInBranch = true;
                }
            }
        }

        if (hasMnemosInBranch) {
            return branch;
        }

        return null;
    }

    function createRootBranch(obj: any) {
        let branch: ITreeAPC_branch = {
            name: obj.subname === null || obj.subname === '' ? obj.name : obj.subname,
            type: 'folder',
            children: [],
            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj.icon
        };

        return branch;
    }

    async function getConf(selectedElem?: string) {
        selectedElem = selectedElem || selectedElement;
        let data = window.Base.GetObject();
        let tree = updateConf(data, selectedElem);
        if (!tree) {
            tree = createRootBranch(data);
        }

        setTree([tree]);
        setBaseData(data);
        setLoadState(true);
    }

    if (!loadState) {
        return <LoadPage visible={true} />;
    } else {
        return (
            <>
                <Header
                    homeElement={
                        <Link to={'/ixyber/vision/display/base'} title="Главная">
                            <IconButton imageUrl="Home" size="medium" />
                        </Link>
                    }
                    userName={auth.nameUser}
                    isAllowed={auth.settingTrue}
                    isAuthenticated={auth.authenticated}
                    privateElements={
                        <>
                            <Link to="/ixyber/vision/display/settingmain" title="Настройки">
                                <IconButton imageUrl="Setting" size="medium" />
                            </Link>
                            <Link to="/ixyber/vision/display/EditorVision" title="Редактор">
                                <IconButton imageUrl="Editor" size="medium" />
                            </Link>
                        </>
                    }
                    callbackLogin={() => {
                        auth.callbackLogin();
                    }}
                    callbackLogout={() => {
                        auth.callbackLogout();
                    }}></Header>
                <div style={{ height: 'calc(100% - 45px)', display: 'flex' }}>
                    {visibleTree ? (
                        <div style={{ position: 'relative' }}>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    height: '50px',
                                    width: '50px'
                                }}
                                onClick={() => {
                                    setOpenWindowTree(true);
                                }}>
                                <svg
                                    style={{ paddingLeft: '20px' }}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1 2H21M1 10.4615H21M1 18.9231H21"
                                        stroke="#AEAEAE"
                                        strokeWidth="1.4"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                            <div
                                className="no-print"
                                style={{
                                    position: 'absolute',
                                    zIndex: 10,
                                    marginTop: '5px',
                                    top: 0,
                                    left: openWindowTree || pinWindowTree ? `0` : `-290px`,
                                    borderRadius: '10px',
                                    display: 'flex',
                                    height: 'calc(100% - 10px)',
                                    width: `300px`,
                                    boxShadow: '-2px -2px 4px rgba(0, 0, 0, 0.05), 2px 2px 4px rgba(0, 0, 0, 0.05)',
                                    overflow: 'auto',
                                    transition: 'left 0.3s ease-in-out'
                                }}
                                onMouseEnter={() => setOpenWindowTree(true)}
                                onMouseLeave={() => setOpenWindowTree(false)}>
                                <div
                                    style={{
                                        background: '#fff',
                                        height: '100%',
                                        width: '100%',
                                        overflow: 'auto'
                                    }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '2.8em',
                                                width: '3.2em'
                                            }}
                                            onClick={() => {
                                                setOpenWindowTree(false);
                                            }}>
                                            <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.9265 4.16948L7.56348 7.5913C7.34154 7.81727 7.34154 8.18159 7.56348 8.40986L10.9242 11.8317C11.0352 11.9447 11.1801 12 11.325 12C11.47 12 11.6149 11.9447 11.7259 11.8317C11.9478 11.6057 11.9478 11.2414 11.7259 11.0154L8.76374 7.99943L11.7281 4.98573C11.9501 4.75976 11.9501 4.39545 11.7281 4.16948C11.5062 3.94351 11.1484 3.94351 10.9265 4.16948Z"
                                                    fill="#AEAEAE"
                                                />
                                                <path
                                                    d="M7.52717 4.16948L4.16645 7.5913C3.94452 7.81727 3.94452 8.18159 4.16645 8.40986L7.52717 11.8317C7.63814 11.9447 7.78308 12 7.92801 12C8.07295 12 8.21789 11.9447 8.32885 11.8317C8.55079 11.6057 8.55079 11.2414 8.32885 11.0154L5.36671 7.99943L8.32885 4.98573C8.55079 4.75976 8.55079 4.39545 8.32885 4.16948C8.10692 3.94351 7.74911 3.94351 7.52717 4.16948Z"
                                                    fill="#AEAEAE"
                                                />
                                            </svg>
                                        </div>
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '2.8em',
                                                width: '3.2em'
                                            }}
                                            title="Закрепить"
                                            onClick={() => setPinWindowTree((prevState) => !prevState)}>
                                            <svg
                                                fill={pinWindowTree ? '#92d8e1' : '#aeaeae'}
                                                width="13px"
                                                height="13px"
                                                viewBox="0 0 32 32"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.714 11.864l-11.505-11.563c-0.248-0.249-0.605-0.35-0.948-0.266-0.341 0.083-0.613 0.339-0.717 0.674-0.692 2.228-0.773 4.245-0.244 6.084-0.049 0.034-0.095 0.070-0.138 0.113l-5.347 5.346c-1.725-0.8-3.579-1.233-5.428-1.233-1.175 0-2.327 0.174-3.424 0.515-0.334 0.104-0.59 0.375-0.674 0.714s0.014 0.698 0.261 0.947l6.843 6.887-9.568 9.72-0.832 2.192 2.011-0.777 9.793-9.72 6.932 6.977c0.189 0.192 0.447 0.295 0.709 0.295 0.079 0 0.159-0.010 0.238-0.029 0.341-0.084 0.613-0.34 0.717-0.675 0.905-2.913 0.64-6.042-0.636-8.848l5.459-5.46c0.020-0.020 0.033-0.041 0.051-0.063 0.824 0.236 1.678 0.361 2.564 0.361 1.101 0 2.268-0.158 3.468-0.531 0.334-0.104 0.59-0.375 0.674-0.714s-0.015-0.697-0.262-0.945zM18.849 25.755l-12.587-12.669c3.23-0.377 6.714 0.925 9.236 3.447 2.51 2.509 3.735 5.978 3.351 9.221zM18.757 17.392c-0.526-0.804-1.14-1.568-1.845-2.274-0.702-0.702-1.469-1.321-2.28-1.854l4.504-4.503c0.459 0.799 1.052 1.563 1.782 2.291 0.745 0.745 1.534 1.348 2.363 1.814zM22.332 9.639c-1.923-1.923-2.664-4.067-2.271-6.653l8.966 9.012c-2.583 0.37-4.738-0.403-6.695-2.36z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <div style={{ height: 'calc(100% - 1.6em)', width: '100%', marginTop: '-1.2em' }}>
                                        <div style={{ padding: '1.2em' }}>
                                            <TreeAPC inpArr={tree} selectedBranch={selectedBranch} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}
                    <div
                        style={{
                            height: '100%',
                            flexGrow: 1
                        }}>
                        {visibleTree && (
                            <div style={{ height: '40px' }}>
                                <div style={{ padding: '15px 0px 0px 10px', fontSize: '15px', color: '#6C6B6B' }}>
                                    {selectedElementPath}
                                </div>
                            </div>
                        )}
                        <div
                            style={{
                                height: `calc(100% - ${visibleTree ? '50px' : '0px'})`,
                                padding: `${visibleTree ? '0 10px 10px 0' : '0'}`
                            }}>
                            <iframe
                                style={{ background: '#F0F9FA', borderRadius: `${visibleTree ? '10px' : '0px'}` }}
                                id="mainframe"
                                name="mainframe"
                                className="webelement-main__frame yes-print"></iframe>
                        </div>
                    </div>
                </div>
                <PopupMessage />
                <ToastList data={toasts} position="top_center" removeToast={removeToast} />
            </>
        );
    }
};

export default observer(MainControl);

//<Reports startFilterName={'fromValue'} startFilterVal={'OFF'} filterListCol={['userID']} />
